import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  COLLECTIONS_NAME,
  COMPONENT_NAME_MODAL,
  FORM_MESSAGES,
  LIST_DATA_EVENTS,
  LOCAL_STORAGE
} from "@/shared/constants/FormConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import {
  CUPS_ACCESS,
  CUPS_FILTERS,
  CUPS_PRICE_LEVEL_CONSTANTS
} from "./constants/CupsPriceLevelConstants";
import { CupsPriceLevelService } from "./services/CupsPriceLevelService";
import { Component, Inject, Vue, Watch } from "vue-property-decorator";
import EmptyState from "@/shared/components/EmptyState/EmptyState.vue";
import ScrollBottom from "../../shared/components/ScrollBottom/ScrollBottom.vue";
import { Http } from "@status/codes";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ObservationModal from "@/shared/components/ObservationModal/ObservationModal.vue";
import {
  GENERAL_CONSTANTS,
  PANEL_INFO_CONSTANTS,
  STATE,
  STORE_CONSTANTS
} from "@/shared/constants/GeneralConstants";
import { SearchContext } from "@/shared/models/SearchContext";
import store from "@/store";
import { Route, NavigationGuardNext } from "vue-router";
import { mapGetters } from "vuex";
import { MenuDataStructure } from "@/shared/models/MenuDataStructure";
import { QuerySend } from "@/shared/models/FormQuerySend";
import { CupsPriceLevelFilter } from "./models/CupsPriceLevelFilter.model";
import { Filter } from "../Dashboards/AdminDashboard/models/Filter";
import CrudChart from "@/shared/components/CrudChart/CrudChart.vue";
import { CHART_INIT } from "@/shared/components/CrudChart/constants/CrudChartConstants";
import { CrudChartRenderData } from "../Dashboards/AdminDashboard/models/CrudChartRenderData";
import { Utils } from "@/shared/utils/utils";
import SaveCupsPriceLevel from "./components/SaveCupsPriceLevel/SaveCupsPriceLevel.vue";
import { AxiosError } from "axios";

Component.registerHooks(["beforeRouteLeave"]);
@Component({
  name: "CupsPriceLevels",
  components: {
    EmptyState,
    ScrollBottom,
    ObservationModal,
    ModalTemplate,
    CrudChart,
    SaveCupsPriceLevel
  },
  computed: {
    ...mapGetters({
      dataToMainView: "getDataToMainView"
    })
  }
})
export default class CupsPriceLevels extends Vue {
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;

  dataToMainView!: MenuDataStructure;

  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  primaryBtnRoundClass = STYLE_CLASSES.PRIMARY_ROUND_BTN;
  secondaryBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  EMPTY_STATE_HEADER = FORM_MESSAGES.INFO_MESSAGE.NO_INFO_TO_SHOW;
  EMPTY_STATE_PARAGRAPH = FORM_MESSAGES.INFO_MESSAGE.EMPTY_STATE_TEXT;
  PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_SEARCH;
  OPERATIONS: string[] = [];
  roundBtnClassTertiary = STYLE_CLASSES.TERTIARY_ROUND_BTN;

  idReference = "";
  admin = false;
  showCharts = false;
  filterItems: Filter[] = CUPS_FILTERS;
  querySearch?: QuerySend = {};
  chartDataGroupState: CrudChartRenderData = CHART_INIT;
  ADD_PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CREATE;
  currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
  currentTooltip = CUPS_PRICE_LEVEL_CONSTANTS.BUTTON.ADD_CUPS_PRICE;
  isLoadingChart = false;
  showCupsComponent = false;
  chosenDocumentId = "";

  /* eslint-disable-next-line  @typescript-eslint/no-empty-function */
  callbackHandleContextPanel: Function = () => {};

  @Watch("dataToMainView")
  dataToMainViewHandler() {
    if (
      this.dataToMainView.from === PANEL_INFO_CONSTANTS.FROM.PANEL &&
      this.dataToMainView.type === PANEL_INFO_CONSTANTS.TYPE.SEARCH
    ) {
      switch (this.dataToMainView.action) {
        case PANEL_INFO_CONSTANTS.ACTION.DO_SEARCH_TEMPLATE:
          this.querySearch = this.dataToMainView.data;
          this.getDataChart();
          break;
        case PANEL_INFO_CONSTANTS.ACTION.SHOW_CRUD_SAVE:
          this.onButtonAdd();
          break;
      }
    }
  }

  sendDataToLateralMenu(action: string, data?: unknown) {
    store.commit(STORE_CONSTANTS.TO_LATERAL_MENU, {
      from: PANEL_INFO_CONSTANTS.FROM.CRUD,
      type: PANEL_INFO_CONSTANTS.TYPE.SEARCH,
      action: action,
      data: data
    });
  }

  mounted() {
    const views = localStorage.getItem(LOCAL_STORAGE.VIEWS);

    if (
      (JSON.parse(views as string) as string[]).includes(
        LOCAL_STORAGE.ADMIN_ROLE
      )
    ) {
      this.admin = true;
    }

    this.OPERATIONS = Utils.addExtraOperations(
      this.OPERATIONS,
      COLLECTIONS_NAME.CUPS_PRICE_LEVEL
    );

    this.emitSearchInitializer();
    this.getDataChart();
  }

  async handleOperation(action: string, itemId: string) {
    switch (action) {
      case LIST_DATA_EVENTS.EDIT_DATA:
        this.loadCups(action, itemId);
        break;
      case LIST_DATA_EVENTS.DELETE_DATA:
        this.deleteCupsPriceLevel(itemId);
        this.cancelData();
        break;
      case LIST_DATA_EVENTS.ACTIVE_DATA:
        this.updateStateCupsPriceLevel(itemId, STATE.ACTIVE);
        this.cancelData();
        break;
      case LIST_DATA_EVENTS.DESACTIVED_DATA:
        this.updateStateCupsPriceLevel(itemId, STATE.INACTIVE);
        this.cancelData();
        break;
      case LIST_DATA_EVENTS.CANCEL_DATA:
        this.cancelData();
        break;
    }
  }

  cancelData() {
    this.currentIcon = GENERAL_CONSTANTS.ICONS.ADD;
    this.PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_SEARCH;
    this.currentTooltip = this.ADD_PAGE_TITLE;
    this.showCupsComponent = false;
    this.chosenDocumentId = "";
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
      ""
    );
  }

  async deleteCupsPriceLevel(id: string) {
    try {
      const responseData = await this.cupsPriceLevelService.deleteCupsPriceLevel(
        id
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.getDataChart();
      } else if (responseData.code === Http.Found) {
        Snackbar.popWarning(
          CUPS_PRICE_LEVEL_CONSTANTS.MESSAGE.CUPS_PRICE_LEVEL_USED
        );
      } else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.DELETE);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async updateStateCupsPriceLevel(CupsPriceId: string, state: string) {
    try {
      const responseData = await this.cupsPriceLevelService.updateStateCupsPriceLevelById(
        CupsPriceId,
        state
      );

      if (responseData.code === Http.Ok) {
        Snackbar.popSuccess(responseData.message);
        await this.getDataChart();
      } else {
        Snackbar.popError(responseData.message);
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.PUT);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
    }
  }

  async emitSearchInitializer() {
    const searchContext: SearchContext = {
      title: this.PAGE_TITLE,
      filterArray: this.filterItems,
      operations: this.OPERATIONS,
      clickAction: LIST_DATA_EVENTS.EDIT_DATA,
      callbackHandleOperation: this.handleOperation,
      descriptions: ["state"],
      optionsToFilter: [],
      componentName: COMPONENT_NAME_MODAL.CUPS_PRICE_LEVEL,
      textButtonCreate: CUPS_PRICE_LEVEL_CONSTANTS.BUTTON.ADD_CUPS_PRICE
    };
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.SET_SEARCH_CONTEXT,
      searchContext
    );
  }

  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    this.sendDataToLateralMenu(
      PANEL_INFO_CONSTANTS.ACTION.DISABLE_SEARCH_CONTEXT
    );
    next();
  }

  async getDataChart() {
    try {
      this.isLoadingChart = true;

      const filterQuery: CupsPriceLevelFilter = {};

      if (this.querySearch?.state) {
        filterQuery.statesList = (this.querySearch
          .state as unknown) as string[];
      }

      if (this.querySearch?.name) {
        filterQuery.externalName = this.querySearch.name[0];
      }

      const response = await this.cupsPriceLevelService.getChart(filterQuery);

      if (response.code === Http.Found && response.data) {
        this.chartDataGroupState = {
          chartTitle: CUPS_PRICE_LEVEL_CONSTANTS.GRAPHS.STATE,
          chartRenderData: Utils.mapChartData(response.data.chartData, "state")
        };

        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_LIST_ITEM_CONTEXT,
          response.data["cupsArray"]
        );

        this.showCharts = true;
      } else {
        this.showCharts = false;
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.RESET_SEARCH_CONTEXT
        );
      }
    } catch (error) {
      if ((error as AxiosError).response?.status == Http.Forbidden)
        Snackbar.popError(FORM_MESSAGES.FORBIDDEN_REQUEST + CUPS_ACCESS.GET);
      else Snackbar.popError(FORM_MESSAGES.REQUEST_FAILED);
      this.showCharts = false;
    }
    this.isLoadingChart = false;
  }

  setDataGroupState() {
    delete this.querySearch?.state;
    this.getDataChart();
  }

  async stateChartClick(label: string) {
    const graphFilter = { ...this.querySearch, state: [label] };
    this.querySearch = (graphFilter as unknown) as QuerySend;
    this.getDataChart();
  }

  showCupsPriceLvl(action: string, editId?: string) {
    if (action === CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_SEARCH) {
      if (this.currentIcon === GENERAL_CONSTANTS.ICONS.ADD) {
        this.chosenDocumentId = "";
        this.PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_CREATE;
        this.show(true);
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM_NULL
        );
        Utils.scrollToElement(CUPS_PRICE_LEVEL_CONSTANTS.SAVE_CUPS_ID, this);
      } else {
        this.cupsCancel();
        this.PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_SEARCH;
      }
    } else if (action === LIST_DATA_EVENTS.EDIT_DATA && editId !== undefined) {
      this.chosenDocumentId = editId;
      this.show(true, editId);
      this.PAGE_TITLE = CUPS_PRICE_LEVEL_CONSTANTS.PAGE_TITLE_EDIT;
    } else {
      this.show(false);
    }
  }

  show(val: boolean, itemId?: string) {
    if (val) {
      this.showCupsComponent = val;
      this.currentIcon = GENERAL_CONSTANTS.ICONS.CANCEL;
      this.currentTooltip = CUPS_PRICE_LEVEL_CONSTANTS.TOOLTIP_CANCEL;
      if (itemId) {
        this.sendDataToLateralMenu(
          PANEL_INFO_CONSTANTS.ACTION.SET_SELECTED_ITEM,
          itemId
        );
      }
    } else {
      this.cupsCancel();
    }
  }

  cupsCancel() {
    this.sendDataToLateralMenu(PANEL_INFO_CONSTANTS.ACTION.MODAL_CANCEL);
  }

  async updateCups() {
    this.handleOperation(LIST_DATA_EVENTS.CANCEL_DATA, "");
    await this.getDataChart();
  }

  loadCups(action: string, itemId: string) {
    this.showCupsPriceLvl(action, itemId);
    Utils.scrollToElement(CUPS_PRICE_LEVEL_CONSTANTS.SAVE_CUPS_ID, this);
  }

  scroll() {
    Utils.scrollToElement(CUPS_PRICE_LEVEL_CONSTANTS.SAVE_CUPS_ID, this);
  }

  onButtonAdd() {
    this.showCupsPriceLvl(this.PAGE_TITLE);
  }
}
